import { NgModule } from '@angular/core';
import { AppointmentsComponent } from './appointments/appointments.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseHighlightModule } from '@fuse/components';
import { TasksComponent } from './tasks/tasks.component';
import { StatCountComponent } from './stat-count/stat-count.component';
import { FuseWidgetModule } from '../fuse/components/widget/widget.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TareasTabComponent } from './tasks/tareas-tab/tareas-tab.component';
import { AngularMaterialModule } from 'app/angular-material.module';
import { SharedModule } from '../common/shared.module';
import { DoctorsViewComponent } from './doctors-view.component';
import { EmployeeModule } from '../employee/employee.module';
import { AppointmentsService } from './services/appointments.service';
import { AgendaService } from './services/agenda.service';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';


@NgModule({
    declarations: [
        DoctorsViewComponent, 
        AppointmentsComponent,
        TasksComponent,
        StatCountComponent,
        TareasTabComponent
    ],
    exports: [
        AppointmentsComponent,
        TasksComponent,
        StatCountComponent,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
    ],
    imports: [
        FuseShortcutsModule,
        CommonModule,
        RouterModule,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        AngularMaterialModule,
        SharedModule,
        EmployeeModule,
    ],
    providers: [
        AppointmentsService,
        AgendaService
    ]
})
export class DoctorsViewModule {
}
